export const getNextQuestion = (steps, nextQuestion, index) => {
    if (nextQuestion === 'next_question' || !nextQuestion) {
        const step = steps[index];
        if (!step) return null;
        return step.uuid || index + 1;
    }

    return Number(nextQuestion);
};
